import { CreatorIntegrationsApiClient } from '@fourthwall/services/dist/CreatorIntegrationsApiClient'
import { createMutationHook } from '@fourthwall/utils/dist/queries'

export const useKlaviyoCreateSyncMutation = createMutationHook(
  CreatorIntegrationsApiClient.createKlaviyoSyncJob,
  {
    mutationKey: ['createKlaviyoSync'],
  },
)
